module.exports = __webpack_public_path__ + "static/media/device-quiz@2x.6a24e85c.png";